import { observer } from 'mobx-react';

import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import { AssetInfoContainer } from './AssetInfo.styles';
import LabelValue from './LabelValue/LabelValue';
import Alerts from './Alerts/Alerts';
import ServiceInfo from './ServiceInfo/ServiceInfo';
import RealtimeData from './RealtimeData/RealtimeData';
import { useLabelValueItemsByDeviceType } from './AssetInfo.utils';

const AssetInfo = observer(({ entity }: { entity: Entity }) => {
  const labelValueItems = useLabelValueItemsByDeviceType(entity);

  return (
    <AssetInfoContainer>
      <div className="label-value-container">
        {labelValueItems.map(item => (
          <LabelValue key={item.label} label={item.label} value={item.value} unit={item.unit} />
        ))}
      </div>
      <div className="card-container">
        <RealtimeData entity={entity} />
      </div>
      <ServiceInfo entity={entity} />
      <div className="card-container">
        <Alerts entity={entity} />
      </div>
    </AssetInfoContainer>
  );
});

export default AssetInfo;
